import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IOriginalDataFormMeta {
  // Original Data
  originalMessageType: FormInputMeta;
  originalAcquirerAuthentication: FormInputMeta;
  originalTraceAuditNumber: FormInputMeta;
  originalForwardingAuthentication: FormInputMeta;
  originalDateTime: FormInputMeta;
  // Additional Amount
  accountType1: FormInputMeta;
  accountType2: FormInputMeta;
  amountType1: FormInputMeta;
  amountType2: FormInputMeta;
  currencyCode1: FormInputMeta;
  currencyCode2: FormInputMeta;
  amount1: FormInputMeta;
  sens1: FormInputMeta;
  amount2: FormInputMeta;
  sens2: FormInputMeta;
  // Original Response Data For Suspicious Authorizations
  responseAction: FormInputMeta;
  responseCode : FormInputMeta;
  additionalResponseReason: FormInputMeta;
  

  schema: any;
}

const OriginalDataFormMeta = {} as IOriginalDataFormMeta;

// Original Data
OriginalDataFormMeta.originalMessageType = {
  name: 'originalMessageType',
  type: 'text',
  label: 'Type de message d\'origine',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
OriginalDataFormMeta.originalAcquirerAuthentication = {
  name: 'originalAcquirerAuthentication',
  type: 'text',
  label: 'Authentification de l\'acquéreur d\'origine',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
OriginalDataFormMeta.originalTraceAuditNumber = {
  name: 'originalTraceAuditNumber',
  type: 'text',
  label: 'Numéro d\'audit de trace d\'origine',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
OriginalDataFormMeta.originalForwardingAuthentication = {
  name: 'originalForwardingAuthentication',
  type: 'text',
  label: 'Authentification de l\'expéditeur d\'origine',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
OriginalDataFormMeta.originalDateTime = {
  name: 'originalDateTime',
  type: 'text',
  label: 'Date et heure d\'origine',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},


 // Additional Amount
OriginalDataFormMeta.accountType1 = {
  name: 'accountType1',
  type: 'text',
  label: 'Type de compte 1',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.accountType2 = {
  name: 'accountType2',
  type: 'text',
  label: 'Type de compte 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.amountType1 = {
  name: 'amountType1',
  type: 'text',
  label: 'Type montant 1',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.amountType2 = {
  name: 'amountType2',
  type: 'text',
  label: 'Type montant 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.currencyCode1 = {
  name: 'currencyCode1',
  type: 'text',
  label: 'Code devise 1',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.currencyCode2 = {
  name: 'currencyCode2',
  type: 'text',
  label: 'Code devise 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.amount1 = {
  name: 'amount1',
  type: 'text',
  label: 'Montant 1',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.sens1 = {
  name: 'sens1',
  type: 'text',
  label: 'Sens 1 ',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.amount2 = {
  name: 'amount2',
  type: 'text',
  label: 'Montant 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.sens2 = {
  name: 'sens2',
  type: 'text',
  label: 'Sens 2',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Original Response Data For Suspicious Authorizations
OriginalDataFormMeta.responseAction = {
  name: 'responseAction',
  type: 'text',
  label: 'Réponse action',
  value: 'En ligne/Hors ligne Avec l\'émetteur'
}
OriginalDataFormMeta.responseCode = {
  name: 'responseCode',
  type: 'text',
  label: 'Code de réponse',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
OriginalDataFormMeta.additionalResponseReason = {
  name: 'additionalResponseReason',
  type: 'text',
  label: 'Raison de la réponse supplémentaire',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}


OriginalDataFormMeta.schema = yup.object().shape(getValidationSchema(OriginalDataFormMeta));

export default OriginalDataFormMeta;